import { Component, OnInit } from '@angular/core';
import { LogService } from '../../_shared/log.service';
import { AuthenticationService } from '@app/_services/authentication.service';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})


export class NavComponent implements OnInit {
  UserName: string;
  UserNameFirstLetter: string;
  returnUrl: string;
  universityDashboard: any = false;
  verifierDocVerifier: any = false
  getresponse: any;
  getresponseNew: any;
  roleId: string;
  tabName: string;
  studEmpDashboard: any = false;
  studEmpMasters: any = false;
  studEmpUploadDocuments: any = false;
  studEmpRequest: any = false;
  studEmpDisputes: any = false;
  studEmpSearchDocuments: any = false;
  studEmpPerformanceDashboard: any = false;
  studEmpSearchOnlyDocuments: any = false;
  RecordEntry: any = false;
  
  constructor(private eventService: LogService, private authenticationService: AuthenticationService, private router: Router,) { }

  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
    console.log("dataval ====", dataValue)
    switch (dataValue) {
      case 1:
        $('.navbar-light .active').removeClass('active');
        $('#requestDropdown').addClass('active');
        $('#docverifyLink').addClass('active');
        break;
      case 2:
        $('.navbar-light .active').removeClass('active');
        $('#disputesLink').addClass('active');
        break;
      case 3:
        $('.navbar-light .active').removeClass('active');
        $('#requestDropdown').addClass('active');
        $('#offlineVerifyLink').addClass('active');
        break;
      case 4:
        $('.navbar-light .active').removeClass('active');
        $('#masterDropdown').addClass('active');
        $('#docMasterLink').addClass('active');
        break;
      case 7:
        $('.navbar-light .active').removeClass('active');
        $('#masterDropdown').addClass('active');
        $('#streamMasterLink').addClass('active');
        break;
      case 10:
        $('.navbar-light .active').removeClass('active');
        $('#masterDropdown').addClass('active');
        $('#priceMasterLink').addClass('active');
        break;
      case 13:
        $('.navbar-light .active').removeClass('active');
        $('#masterDropdown').addClass('active');
        $('#collegeMasterLink').addClass('active');
        break;
      case 16:
        $('.navbar-light .active').removeClass('active');
        $('#masterDropdown').addClass('active');
        $('#userMasterLink').addClass('active');
        break;
      case 17:
        $('.navbar-light .active').removeClass('active');
        $('#dashboardLink').addClass('active');
        break;
      case 18:
        $('.navbar-light .active').removeClass('active');
        $('#UploadDocumentsLink').addClass('active');
        break;
      case 18:
        $('.navbar-light .active').removeClass('active');
        $('#SearchDocumentsLink').addClass('active');
        break;
      case 18:
        $('.navbar-light .active').removeClass('active');
        $('#dashboardPerformanceLink').addClass('active');
        break;
      case 18:
        $('.navbar-light .active').removeClass('active');
        $('#studEmpSearchOnlyDocumentsLink').addClass('active');
        break;
      case 19:
        $('.navbar-light .active').removeClass('active');
        $('#passingYearLink').addClass('active');
        break;
      case 20:
        $('.navbar-light .active').removeClass('active');
        $('#RecordEntryLink').addClass('active');
        break;
      // case 26:
      //   $('.navbar-light .active').removeClass('active');
      //   $('#universityDocVerificationLink').addClass('active');
      //   break;
      // case 40:
      //   $('.navbar-light .active').removeClass('active');
      //   $('#universityDashboardLink').addClass('active');
      //   break;
        
    }
  }

  ngOnInit(): void {
    this.UserName = localStorage.getItem('userName');
    this.UserName = this.UserName.replace(/['"]+/g, '')
    this.UserNameFirstLetter = this.UserName.charAt(0);

    const url = window.location.href;

    if (url.includes("student") || url.includes("employer")) {

      this.studEmpDashboard = false;
      this.studEmpMasters = false;
      this.studEmpUploadDocuments = false;
      this.studEmpRequest = false;
      this.studEmpDisputes = false;
      this.universityDashboard = false
      this.verifierDocVerifier = false
    }
    if(url.includes("university")){
      this.studEmpDashboard = false
      this.studEmpMasters = false
      this.studEmpUploadDocuments = false
      this.studEmpRequest = false
      this.universityDashboard = true
      this.studEmpPerformanceDashboard = false
      this.studEmpMasters = false
      this.studEmpDisputes = false
      this.studEmpUploadDocuments = false
      this.studEmpRequest = false
      this.studEmpSearchDocuments = false
      this.studEmpSearchOnlyDocuments = false
      this.RecordEntry = false
    }
    if(url.includes("verifier")){
      this.verifierDocVerifier = true
      this.studEmpDashboard = false
      this.studEmpMasters = false
      this.studEmpUploadDocuments = false
      this.studEmpRequest = false
      this.universityDashboard = false
      this.studEmpPerformanceDashboard = false
      this.studEmpMasters = false
      this.studEmpDisputes = false
      this.studEmpUploadDocuments = false
      this.studEmpRequest = false
      this.studEmpSearchDocuments = false
      this.studEmpSearchOnlyDocuments = false
      this.RecordEntry = false
    }
    else {
      this.roleId = localStorage.getItem('currentRole');
      //get Menu name as per Role
      this.authenticationService.GetMenuByRole(this.roleId)
        .pipe(first())
        .subscribe(
          response => {
            console.log("response===", response)
            if (response) {
              this.getresponseNew = response.respData;
            //  this.universityDashboard = false
              this.getresponseNew.forEach(item => {

                // this.getresponseNew.forEach(function (value) {
                // this.tabName = value.tabName;
                if (item.tabName == 'Dashboard') {
                  this.studEmpDashboard = true;
                }
                if (item.tabName == 'PerformanceDashboard') {
                  this.studEmpPerformanceDashboard = true;
                }
                if (item.tabName == 'Masters') {
                  this.studEmpMasters = true;
                }
                if (item.tabName == 'Disputes') {
                  this.studEmpDisputes = true;
                }
                if (item.tabName == 'UploadDocuments') {
                  this.studEmpUploadDocuments = true;
                }
                if (item.tabName == 'Request') {
                  this.studEmpRequest = true;
                }
                if (item.tabName == 'SearchAndEditDocuments') {
                  this.studEmpSearchDocuments = true;
                }
                if (item.tabName == 'SearchOnlyDocuments') {
                  this.studEmpSearchOnlyDocuments = true;
                }
                if (item.tabName == 'RecordEntry') {
                  this.RecordEntry = true;
                }
                // alert(value.tabName);
              });
            }
          })
    }

  }
  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }
  gotoHomePage() {
    this.roleId = localStorage.getItem('currentRole');
    //  alert(this.roleId);


    if (this.roleId == "1")//for student
    {
      this.callDispute("'0'")
      this.returnUrl = "student";
      this.router.navigate([this.returnUrl]);
    }
    else if (this.roleId == "2")//for employer
    {
      this.callDispute("'0'")
      this.returnUrl = "employer";
      this.router.navigate([this.returnUrl]);
    }
    // else if (this.roleId == "3")//for verifier
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "verifier";
    //   this.router.navigate([this.returnUrl]);
    // }
    // else if (this.roleId == "4")//for super verifier
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "superVerifier";
    //   this.router.navigate([this.returnUrl]);
    // }
    // else if (this.roleId == "5")//for  super Admin
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "superAdmin";
    //   this.router.navigate([this.returnUrl]);
    // }

    // else if (this.roleId == "6")//for super Associate
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "associate";
    //   this.router.navigate([this.returnUrl]);
    // }
    // else if (this.roleId == "7")//for university
    // {
    //   this.callDispute("'0'")
    //   this.returnUrl = "university";
    //   this.router.navigate([this.returnUrl]);
    // }

    if (this.roleId == "3")//for verifier
    {
      this.callRoute('27');
    }
    else if (this.roleId == "4")//for super verifier
    {
      this.callRoute('28');
    }
    else if (this.roleId == "5")//for  super Admin
    {
      this.callRoute('29');
    }
    else if (this.roleId == "6")//for  Associate
    {
      this.callRoute('30');
    }
    else if (this.roleId == "8")//for super Associate
    {
      this.callRoute('31');
    }
    else if (this.roleId == "7")//for university
    {
      this.callRoute('26');
    }

  }
  logout() {


    this.authenticationService.logoutVeri()
      .pipe(first())
      .subscribe(
        response => {
          if (response) {
            this.getresponse = response;
          }
        })

    this.authenticationService.logout();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentRole');
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('userName');
    localStorage.removeItem('refreshToken');
    // this.router.navigate(['/login']);
    this.returnUrl = "login";
    this.router.navigate([this.returnUrl]);
  }

}
